<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-half">
        <div class="box">
          <admin-box-item title="기본 정보">
            <div class="columns is-multiline">
             <!-- <div class="column is-full">
                <admin-form-item label="이미지">
                  <input-img :url.sync="basicInfo.profile"></input-img>
                </admin-form-item>
              </div>-->
              <div class="column is-half">
                <admin-form-item label="아이디*">
                  <input class="input"
                          :value="basicInfo.username"
                          @input="inputUserName"
                          placeholder="launchpack"
                          type="text" :disabled="inputDisabled" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="이름">
                  <input class="input"
                          :value="basicInfo.name"
                          @input="e => basicInfo.name = e.target.value"
                          placeholder="홍길동"
                          type="text">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호*">
                  <input class="input"
                        :value="basicInfo.password"
                        @input="e => basicInfo.password = e.target.value"
                         placeholder="비밀번호를 입력하세요."
                         type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-half">
                <admin-form-item label="비밀번호 확인*">
                  <input class="input"
                        :value="basicInfo.passwordCheck"
                        @input="e => basicInfo.passwordCheck = e.target.value"
                        placeholder="비밀번호를 확인하는 곳 입니다."
                        type="password" maxlength="15">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="휴대전화번호">
                  <input class="input"
                        :value="basicInfo.phone"
                        @input="e => basicInfo.phone = e.target.value"
                         placeholder="010-1234-5678"
                        type="text" maxlength="13">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <div class="box">
      <admin-box-item title="매핑된 팀 정보">
        <div class="columns is-multiline">
          <div class="column is-full">
            <admin-form-item label="팀 검색">
              <button class="button is-primary"
                      @click="$modal.show('groupListModal')">팀검색</button>
            </admin-form-item>
          </div>
        </div>
      </admin-box-item>
    </div>

    <div class="box">
      <admin-box-item title="팀 정보">
        <div style="overflow-x: auto">
          <div style="min-width:600px">
            <table class="table">
              <tbody>
              <tr class="tr-whole-border">
                <th style="width: 40px;">id</th>
                <th style="width: 72px;">생성일</th>
                <th style="width: 40px;">팀이름</th>
                <th style="width: 80px;">간단설명</th>
                <th style="width: 40px;">삭제</th>
              </tr>

              <tr v-for="(pi,idx) in groupTable" :key="'group-item'+idx" class="lp-row many-field-tr">
                <td>{{ pi.id }}</td>
                <td>{{ pi.created_time }}</td>
                <td><span>{{ pi.name }}</span></td>
                <td>{{ pi.simple_desc }}</td>
                <td><button class="button is-danger" @click="deleteGroup(idx)">삭제</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </admin-box-item>
    </div>

                <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <modal name="groupListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <group-list @groupItems="groupItems" page="superpartner" :selectedItems="id_list" style="zoom: 0.85"></group-list>
    </modal>

  </div>
</template>

<script>
  import moment from 'moment';
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import InputImg from '../../module/common/InputImg'
  import LpAddress from '../../module/common/LpAddress'
  import LpAdmDropInput from '../../module/common/LpAdmDropInput'
  import LpDateDropInput from "../../module/common/LpDateDropInput";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import InputParam from "../../module/custom/InputParam";
  import GroupList from "../group/GroupList";
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    layout: 'Main',
    components: {
      GroupList,
      InputParam,
      LpSortDropDown,
      LpDateDropInput,
      LpInputText,
      LpRadio, InputImg, LpAddress,
      LpAdmDropInput
    },
    mixins: [
      CreateMixin
    ],
    data() {
      return {
        testModal: false,
        // 연락처
        phone: [
          {label: ''}
        ],
        // 기본 정보
        basicInfo: {
          birth: {
            year: '',
            month: '',
            date: '',
          },
          gender: '',
          profile: '',
          username: '',
          // id: '',
          password: '',
          passwordCheck: '',
          email: '',
          address: {
            full: '',
            sido: '',
            sigungu: '',
            dong: '',
            zipcode: '',
            detail: ''
          },
          name: '',
          nickname: '',
          joined_type: '',
          phone: '',
          groups: []
        },
        // 성별 라디오 용
        gender: [
          {label: '여자', value: 'female'},
          {label: '남자', value: 'male'},
        ],
        // 생년월일 Array
        yearArr: [],
        monthArr: [],
        dateArr: [],
        emailValid: false,
        userGradeList: [],
        groupArr:[],
        id_list: [],
        // 그룹정보
        groupTable: []
      }
    },
    computed: {
      inputDisabled() {
        if (this.$route.query.id) {
          return true;
        }
      },
      selectedGrade() {
        let grade = find(this.userGradeList, 'value', this.basicInfo.grade);
        if(grade)
          return grade.label;
        else
          return '';
      },
      userName() {
        let user = find(this.emailArr, 'value', this.basicInfo.username2);
        if (user !== undefined)
          return user.label;
        else
          return '';
      }
    },
    watch: {
      'basicInfo.phone'(n) {
        if(n) this.basicInfo.phone = autoHyphenPhone(this.basicInfo.phone)
      },
      'basicInfo.birth.year'(n) {
        this.monthArr = [];
        this.dateArr = [];

        let month = 1;
        for (let i = 0; i < 12; i++) {
          let monthObj = {
            label: month.toString(),
            value: month.toString()
          };
          this.monthArr.push(monthObj);
          month++;
        }

        let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
        day = moment(day).endOf('month').format('DD');

        for (let i = 1; i <= day; i++) {
          this.dateArr.push({
            label: i.toString(),
            value: i.toString()
          });
        }
      },
      'basicInfo.birth.month'(n) {
        this.dateArr = [];
        let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
        day = moment(day).endOf('month').format('DD');

        for (let i = 1; i <= day; i++) {
          this.dateArr.push({
            label: i.toString(),
            value: i.toString()
          });
        }
      },
    },
    created() {
      // 연/월/일 Array 생성
      let century = parseInt(moment().format('YYYY')) - 100;
      for (let year = parseInt(moment().format('YYYY')); year >= century; year--) {
        this.yearArr.push({
          label: year.toString(),
          value: year.toString()
        });
      }

      for (let month = 1; month <= 12; month++) {
        this.monthArr.push({
          label: month.toString(),
          value: month.toString()
        });
      }

      this.getData();

      let day = (this.basicInfo.birth.year).toString() + '-' + (this.basicInfo.birth.month).toString();
      day = moment(day).endOf('month').format('DD');

      for (let i = 1; i <= day; i++) {
        this.dateArr.push({
          label: i.toString(),
          value: i.toString()
        });
      }

    },
    methods: {
      // 그룹 정보 리스트
      groupItems(res) {
        for(let i=0; i<res.id_list.length; i++){
          if(this.id_list.includes(res.id_list[i])===false){
            this.id_list.push(res.id_list[i]);
            this.groupTable.push(res.groupItems[i]);
            this.basicInfo.groups.push(res.id_list[i]);
          }
        }
        //this.$refs.productListModal.close();
        this.$modal.hide('groupListModal');
      },
      deleteGroup(idx) {
        removeIndex(this.groupTable, idx);
        removeIndex(this.basicInfo.groups, idx);
        removeIndex(this.id_list, idx);
      },

      /*deleteGroup(idx) {
        removeIndex(this.basicInfo.groups,idx);
      },*/
      convertGroupNames(id) {
        return find(this.groupArr, 'value', id).label;
      },
      selectGroup(res) {
        /*let is_group = false;
        for(let i=0; i<this.basicInfo.groups.length; i++) {
          if(this.basicInfo.groups[i].value===res.value) {
            is_group = true;
          }
        }
        if(!is_group) {
          this.basicInfo.groups.push(res);
        }*/

        if(this.basicInfo.groups.indexOf(res.value) === -1) {
          this.basicInfo.groups.push(res.value);
        }
      },
      getGroups() {
        this.$axios.get('public/group/simple').then(res=>{
          this.groupArr = res.data;
        })
      },
      inputUserName (e){
        this.basicInfo.username = e.target.value;
        this.basicInfo.email = e.target.value;
      },
      validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      // 연 선택
      selYear(item) {
        if (item === undefined) return;
        this.basicInfo.birth.year = item.label;
      },
      // 월 선택
      selMonth(item) {
        if (item === undefined) return;
        this.basicInfo.birth.month = item.label;
      },
      // 일 선택
      selDate(item) {
        if (item === undefined) return;
        this.basicInfo.birth.date = item.label;
      },
      getData() {
        this.getGroups();
        // 유저 정보가 있는 경우 가져오기
        if (this.$route.query.id) {
          this.$axios.get(this.getUrl('super-partner/' + this.$route.query.id))
            .then(res => {
              if (res.status === 200) {
                this.basicInfo = res.data.user;
                this.user_param = res.data.params;
                this.groupTable = res.data.user.group_list;
                let birth = res.data.user.birth;
                if (birth) {
                  this.basicInfo.birth = {
                    year: moment(birth).year(),
                    month: moment(birth).month() + 1,
                    date: moment(birth).date()
                  }
                }
                else {
                  this.basicInfo.birth = {
                    year: '',
                    month: '',
                    date: ''
                  }
                }
                let address = res.data.user.address;
                if (!address) {
                  this.basicInfo.address = {
                    sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                  }
                }
              }
            });
        }
      },
      saveData() {
        let errMsg = '';
        if (!this.basicInfo.username) errMsg = '아이디를';
        //else if(!this.basicInfo.name) errMsg = '이름을';
        else if (this.basicInfo.phone && this.basicInfo.phone.split('-').length < 3) errMsg = '휴대전화번호를 알맞게';
        //else if (!this.basicInfo.birth.year || !this.basicInfo.birth.month || !this.basicInfo.birth.date) errMsg = '생년월일을 알맞게'
        // else if (!this.emailValid) errMsg = '이메일 타입에 맞게';
        //else if(this.basicInfo.nickname === '') errMsg = '닉네임을';
        if (!this.$route.query.id) {
          if (!this.basicInfo.password) errMsg = '비밀번호를';
          else if (!this.basicInfo.passwordCheck) errMsg = '비밀번호 확인을';
        }

        if (errMsg) {
          this.toast(errMsg + ' 입력해주세요.');
          return;
        }
        if (this.basicInfo.password !== this.basicInfo.passwordCheck) {
          this.toast('비밀번호를 확인해주세요.');
          return;
        }


        // 생년월일 데이터 맞춰서 보내기
        let basicInfo = this.cloneItem(this.basicInfo);
        let year = basicInfo.birth.year;
        let month = basicInfo.birth.month;
        let date = basicInfo.birth.date;
        let errBirth = false;
        if (!year && !month && !date) {
          basicInfo.birth = '';
        }
        else if (year && !month && !date) errBirth = true;
        else if (year && month && !date) errBirth = true;
        else if (!year && month && date) errBirth = true;
        else if (!year && !month && date) errBirth = true;
        else if (!year && month && !date) errBirth = true;
        else {
          let birth = basicInfo.birth.year + '-' + basicInfo.birth.month + '-' + basicInfo.birth.date
          basicInfo.birth = birth;
        }

        if(errBirth===true) {
          this.toast('생년월일을 모두 선택해주세요.');
          return;
        }

        // 전화번호 (-)하이폰 없애서 보내기
        let phone = '';
        let phone_copy = '';
        if(basicInfo.phone){
          phone = basicInfo.phone.split('-')
          for (let i = 0; i < phone.length; i++) {
            phone_copy += phone[i];
          }
        }
        basicInfo.phone = phone_copy;
        this.$store.commit('setLoading', true);
        if (this.$route.query.id) {
          // user_param 추가
          this.$axios.patch(this.getUrl('super-partner/' + this.$route.query.id), basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('superpartner'));
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          });
        }
        else {
          this.$axios.post(this.getUrl('super-partner'), basicInfo).then(res => {
            if (res.status === 200) {
              this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('superpartner'));
            }
          }).catch(error => {
            if (error.response) {
              this.$store.commit('setLoading', false);
              this.toast(error.response.data.message);
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  .service-usage-info
    display flex
    justify-content space-evenly
    max-width 50%
    min-width 50%
    padding 4px 8px

  .service-usage-info-label
    display inline-block
    width 112px
    min-width 80px
    margin 0

  .user-reg-history-memo
    width 100%
    height 196px
    font-size .9rem
    display flex
    flex-wrap wrap
    border 1px solid #ddd
    border-radius 3px
    padding 12px
    overflow-y auto

  .history-memo-item
    width 100%
    margin-bottom 12px

  .user-reg-history-btn
    background-color $primary
    color #fff
    display inline-block
    padding 8px 12px
    margin-left 8px
    border-radius 3px
    cursor pointer


</style>
